<div *ngIf="!isOpen">
    <div class="row ">
        <div class="col-md-12">
        <h3 class="colorPrincipal">{{title}}</h3>
        </div>
    </div>
</div>
  
<div>
    <div [ngClass]="{'cameraPreview': isOpen}"  id="turn">
        <video autoplay="true" id="video_{{divId}}"  class="video_{{divId}} cameraPreview"
                [hidden]="!isOpen"></video>
        <canvas id="canvas_{{divId}}" class="canvas_{{divId}} cameraPreview"  hidden></canvas>

        <div *ngIf="isOpen">
            <img class="overlay  " [src]="overlay" *ngIf="showOverlay">
            <div class="row centrado mainScreen" >
                <div class="col-sd-3  ">
                    <a class="nav-link  " (click)="captureImage()">
                        <i class="fas fa-camera colorSecundario fa-3x iconsMedia"></i>  </a>
                </div>
                <div class="col-sd-3  ">
                    <a class="nav-link  padding10" (click)="switchCamera()">
                        <i class="fas fa-sync-alt colorSecundario fa-3x iconsMedia"></i>  </a>
                </div>
                <div class="col-sd-3  ">
                    <a class="nav-link " (click)="closeCamera()">
                        <i class="fas fa-sign-out-alt colorSecundario fa-3x iconsMedia"></i>  </a>
                </div>
            </div>
        </div>
    </div>
</div>
<img *ngIf="image" [src]="image">
  
<div class="row " *ngIf="!isOpen">
    <div class="col-md-12 centrado ">
        <div *ngIf="!model" class="card borderSecondary height150 maxW400">
        <div class=" centrado nomargin">
            <img *ngIf="!model" class="imgLogoMini" [src]="defaultBackground" (click)="openCamera()">
            <img *ngIf="model && url" class="imgLogoMini " [src]="url" (click)="openCamera()">
        </div>
        </div>
    </div>
    <div *ngIf="model && url" class="card borderSecondary fullWidth height150 maxW400">
        <img class="cardPictureCamera fullWidth centrado" [src]="url" (click)="openCamera()" >
    </div>
</div>
